import { computed, type ComputedRef } from 'vue'

import { useAdvertiserStore } from '@/stores/advertiser.stores'

type AdvertiserPermissions = {
  hideEdit: ComputedRef<boolean>
  hideCosts: ComputedRef<boolean>
  hideMedia: ComputedRef<boolean>
  hideClicks: ComputedRef<boolean>
  hideSales: ComputedRef<boolean>
  hideUsers: ComputedRef<boolean>
  hideFindInfluencers: ComputedRef<boolean>
  userCanEditAllInfluencers: ComputedRef<boolean>
  advertiserUsesCpa: ComputedRef<boolean>
}

export const useAdvertiserPermissions = (): AdvertiserPermissions => {
  const advertiserStore = useAdvertiserStore()
  const permission = computed(() => advertiserStore.advertiser?.userPermissions?.[0])
  const hiddenItems = computed<string[]>(() => permission.value?.config?.hide ?? [])
  const isHidden = (key: string): ComputedRef<boolean> =>
    computed<boolean>(() => hiddenItems.value.includes(key))

  return {
    hideEdit: isHidden('edit'),
    hideCosts: isHidden('cost'),
    hideMedia: isHidden('media'),
    hideClicks: isHidden('clicks'),
    hideSales: isHidden('sales'),
    hideUsers: isHidden('users'),
    hideFindInfluencers: isHidden('find_influencers'),
    userCanEditAllInfluencers: computed<boolean>(() => permission.value?.editableClientId != null),
    advertiserUsesCpa: computed<boolean>(() =>
      Boolean(advertiserStore.advertiser?.advertiserUseCpa),
    ),
  }
}
